const appConfig = {
  apiPrefix: process.env.REACT_APP_API_PREFIX,
  apiStateOfPlay: process.env.REACT_APP_API_STATE_OF_PLAY,
  apiSimpleUrl: process.env.REACT_APP_API_SIMPLE_URL,
  apiSimpleUrlRetail: process.env.REACT_APP_API_RETAIL,
  apiPricingTool: process.env.REACT_APP_API_PRICING_TOOL,
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: false,
};

export default appConfig;
